module.exports = __webpack_public_path__ + "img/8.020b9723.png";